import DriverPlanEntryCheckoutEventAddRequest from "../../../../../api/raily/driver/plan-entry/checkout-event/add/driver-plan-entry-checkout-event-add.request";
import DriverPlanEntryCheckoutEventAddParams from "./driver-plan-entry-checkout-event-add-params";

const create = (
  params: DriverPlanEntryCheckoutEventAddParams,
): DriverPlanEntryCheckoutEventAddRequest => {
  return {
    achievedAt: params.achievedAt,
    driverUuid: params.driverUuid,
    haltingTime: params.haltingTime,
    highwayCharge: params.highwayCharge,
    nodeId: params.nodeId,
    planEntryUuid: params.planEntryUuid,
  };
};

const driverPlanEntryCheckoutEventAddParamsFactory = {
  create,
};

export default driverPlanEntryCheckoutEventAddParamsFactory;
